import { render, staticRenderFns } from "./feedbackManage.vue?vue&type=template&id=d6ed6e30&scoped=true&"
import script from "./feedbackManage.vue?vue&type=script&lang=js&"
export * from "./feedbackManage.vue?vue&type=script&lang=js&"
import style0 from "./feedbackManage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./feedbackManage.vue?vue&type=style&index=1&id=d6ed6e30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6ed6e30",
  null
  
)

export default component.exports